module.exports = __webpack_public_path__ + "static/flexindicator-076143c683c4ca8c618639f757e503d2.png";